import { colors } from 'styles/colors';
import styled from 'styled-components';

export const Wrapper = styled.div`
  color: ${colors.muted};

  a {
    color: ${colors.ink};
    text-decoration: none;

    &:hover {
      color: ${colors.sea};
    }
  }

  [aria-current] {
    color: ${colors.ink};
    font-weight: bold;
  }

  ${({ mobile }) =>
    mobile &&
    `
			display: none;
			position: absolute;
			top: 50%;
			transform: translateY(-50%);
			/* Just left of the hamburger button (right: 1.8rem, 24px wide) */
			right: calc(1.8rem + 24px + 1.5rem);
			font-size: 1.125rem;

			@media (max-width: 991px) {
				display: block;
			}
	`}
`;
